const detailData = {
  detail: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'vehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
        ],
        data: {},
        approveData: {},
      },
    },
    belong: {
      label: '归属车队',
      tableData: {
        title: [
          {
            prop: 'tenantName',
            label: '车队名称',
          },
          {
            prop: 'linkPhone',
            label: '车队电话',
          },
        ],
        data: {},
        approveData: {},
      },
    },
    applyInfo: {
      label: '',
      tableData: {
        title: [],
      },
    },
    approve: {
      label: '审核结果',
      tableData: {
        title: [
          {
            prop: 'stateName',
            label: '审核状态',
          },
          {
            prop: 'auditDate',
            label: '审核时间',
          },
          {
            prop: 'auditRemark',
            label: '审核意见',
          },
        ],
        data: {},
        approveData: {},
      },
    },
  },
  applyAndInvite: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'applyVehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
          {
            prop: 'vehicleInfo',
            label: '车辆类型',
          },
          {
            prop: 'vehicleLoad',
            label: '车辆载重（吨）',
          },
          {
            prop: 'lightGoodsSquare',
            label: '车辆容积',
          },
        ],
        data: {},
        approveData: {},
      },
    },
    belong: {
      label: '归属车队',
      tableData: {
        title: [
          {
            prop: 'tenantName',
            label: '车队名称',
          },
          {
            prop: 'linkPhone',
            label: '车队电话',
          },
        ],
        data: {},
        approveData: {},
      },
    },
  },
  arbitration: {
    base: {
      label: '基础信息',
      tableData: {
        title: [
          {
            prop: 'plateNumber',
            label: '车牌号码',
          },
          {
            prop: 'applyVehicleClassName',
            label: '车辆种类',
          },
          {
            prop: 'licenceTypeName',
            label: '牌照类型',
          },
        ],
        data: {},
        approveData: {},
      },
    },
  },
};

export default detailData;
